export type SelectionId = string | number | null | undefined

export const toSelectionKey = (value: SelectionId): string =>
  value === null || typeof value === 'undefined' ? '' : String(value)

export const hasSelection = (selectedIds: readonly SelectionId[] = [], id: SelectionId): boolean =>
  selectedIds.some((selectedId) => toSelectionKey(selectedId) === toSelectionKey(id))

export const uniqueSelections = <T extends SelectionId>(ids: readonly T[] = []): T[] =>
  ids.filter(
    (id, index, allIds) =>
      allIds.findIndex((candidateId) => toSelectionKey(candidateId) === toSelectionKey(id)) ===
      index
  )

export const withoutSelections = <T extends SelectionId>(
  selectedIds: readonly T[] = [],
  idsToRemove: readonly SelectionId[] = []
): T[] => {
  const removeKeys = new Set(idsToRemove.map(toSelectionKey))

  return selectedIds.filter((selectedId) => !removeKeys.has(toSelectionKey(selectedId)))
}
